import { FindConnectCommand, PermissionAccess, PermissionVisibility, StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ConfirmationResultObj, FilterComponent, ImageUploadParameter, WizButton, WizCheckbox, WizDatasource, WizDropdown, WizGroupCommand, WizIcon, WizImage, WizPopUp, WizTextarea, WizTextInput, WizTranslationBasic, WizValidationContainerDirective,
  WizValidationError, WizValidationErrors, WizValidatorFn, WizVgroup, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';
import { WizMathUtils, CODE_SPACE, VALUE_ENTER, WIZ_EVENT_TYPE, CONFIRMATION_MODE, CONFIRMATION_RESULT, } from '@wizeoo/akm-core-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { MultiDisplay, MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { ConnectVO } from '@wizeoo/akm-common-lib';
import { FakeVO } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { EM_ACTION } from '@wizeoo/akm-compute-lib';
import { ConnectIconRenderer } from '@wizeoo/akm-common-lib';


/**
 * Vue de gestion des includes / excludes
 * Author LMA
 */
@Component({
  selector: 'connect-view',
  templateUrl: './connect.view.html',
})
export class ConnectView extends BaseView {

  @ViewChild('mdMain') mdMain: MultiDisplay<ConnectVO>; // grid principal

  @ViewChild('vgEdition', { read: WizVgroup }) vgEdition: WizVgroup; // ensemble de la zone de détail pour écoute ModelUpdate
  @ViewChild('vgEdition', { read: WizValidationContainerDirective, static: false })
  private vgEditionCheck: WizValidationContainerDirective; // Zone de validation globale


  @ViewChild('tiCode', { read: WizTextInput }) tiCode: WizTextInput; // champ de saisie du code
  @ViewChild('trsLabel', { read: WizTranslationBasic }) trsLabel: WizTranslationBasic;

  /** Composant de saisie de la description */
  @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic;
  @ViewChild('tiProcessCode', { read: WizTextInput }) tiProcessCode: WizTextInput; // champ de saisie du code
  @ViewChild('ddlProcessMode', { read: WizDropdown }) ddlProcessMode: WizDropdown; // drop de type de données

  @ViewChild('trsWarnTitle', { read: WizTranslationBasic }) trsWarnTitle: WizTranslationBasic;
  @ViewChild('trsWarnDetail', { read: WizTranslationBasic }) trsWarnDetail: WizTranslationBasic;
  @ViewChild('trsResultError', { read: WizTranslationBasic }) trsResultError: WizTranslationBasic;
  @ViewChild('trsResultSuccess', { read: WizTranslationBasic }) trsResultSuccess: WizTranslationBasic;

  @ViewChild('taParameters', { read: WizTextarea }) taParameters: WizTextarea; // params connect
  @ViewChild('ddResultAction', { read: WizDropdown }) ddResultAction: WizDropdown; // type d'action sur retour synchrone
  // @ViewChild('tiResultAction', { read: WizTextInput }) tiResultAction: WizTextInput; // champ de saisie du code
  @ViewChild('cbUseWarning', { read: WizCheckbox }) cbUseWarning: WizCheckbox; // champ de saisie du code

  /** Composant de sélection de l'icone */
  @ViewChild('uploadImg', { read: WizImage }) uploadImg: WizImage;

   /** Bouton de suppression */
   @ViewChild('btnDelete', { read: WizIcon }) btnDelete: WizIcon;
  /** Bouton d'ajout */
  @ViewChild('btnCreate', { read: WizIcon }) btnCreate: WizIcon;
  /** Bouton de sauvegarde */
  @ViewChild('btnSave', { read: WizButton }) btnSave: WizButton;
  /** Bouton d'annulation */
  @ViewChild('btnCancel', { read: WizButton }) btnCancel: WizButton;



  public currentConnect: ConnectVO = null; // sélection active (objet métier vrai)
  public clone: ConnectVO = null; // clone de travail


  /** Constructeur */
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  /** DS du grid principal */
  public mainDS: WizDatasource<ConnectVO> = new WizDatasource<ConnectVO>([])
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop de mode */
  public modeDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().connectModeList)
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS type d'action en retour */
  public resultActionDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().connectReturnActionKind)
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('single')
    .build();

  /** Configuration du mode multi display (principal) */
  public mainConfig: MultiDisplayConfig<ConnectVO> = {
    model: Model.getInstance(),
    datasource: this.mainDS,
    defaultMode: 'grid',
    onSelectionChanging: this.askSelectMain.bind(this),
    grid: {
      enabled: true,
      columns: [
        {
          headerName: ' ',
          field: 'code',
          width: 40,
          cellRenderer: 'connectIconRenderer',
        },
        { headerName: '$.common.code.$', width: 80, sortable: true, field: 'code', tooltipField: 'code' },
        { headerName: '$.common.label.$', minWidth: 50, flex: 1, sortable: true,resizable: true, field: 'trsLabel', tooltipField: 'trsLabel' },   
        { headerName: '$.process.code.$', width: 100, sortable: true,resizable: true, field: 'processCode', tooltipField: 'processCode' },  
  
      ],
      renderers: {
        connectIconRenderer: ConnectIconRenderer,
      },
    },
    filter: {
      enabled: true,
      initFilter: this.initMainFilter.bind(this),
    },
  };

  /* ################################################
                      CYCLE DE VIE
    ################################################ */


  wizBeforeInit() {
    const calls = [];
 
    calls.push(new FindConnectCommand(Model.getInstance()));
    return new WizGroupCommand().configure(calls);
  }


  wizSynchronizeData() {
    super.managePermissions([
      {
        feature: StaticFeatureEnum.CONNECT,
        permissions: [
          {
            component: this.btnCreate,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnDelete,
            accesses: [PermissionAccess.DELETE],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ]);

    this.mainFilter.configure(['code', 'trsLabel', 'processCode'], null, null); // alimentation du filtre principal
    
    const buCnx: Map<string, ConnectVO> = Model.getInstance().connectMapExt?.get(Model.getInstance().domainCode)?.get(Model.getInstance().businessUnitCode);
    const cnxArr: ConnectVO[] = !!buCnx ? [...buCnx.values()] : [];

    this.mainDS.setSource(cnxArr); // alimentation de la liste principale
    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;
    this.ddlProcessMode.wizDataProvider = this.modeDS; // alimentation de la drop des types de données
    this.feed();
  }

  /** alimentation de la zone de détail */
  private feed(): void {
    // TODO ici gestion des permissions

    this.vgEdition.visible = !!this.clone;

    if (!!this.clone) {
      this.tiCode.wizValue = this.clone.code; // alimentation du code
      this.trsLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.labelVO);
      this.trsDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.descriptionVO);

      this.trsWarnTitle.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.warnTitleVO);
      this.trsWarnDetail.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.warnDetailVO);
      this.trsResultError.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.resultErrorVO);
      this.trsResultSuccess.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.resultSuccessVO);

      // this.tiResultAction.wizValue = this.clone.resultAction;
      let ra: FakeVO = null; // le statut en forme "objet"
      if (this.clone.resultAction) {
        ra = this.resultActionDS.getItemByKey(this.clone.resultAction);
      }
      this.resultActionDS.select([ra]);

      this.taParameters.wizValue = this.clone.trsParameters;
      this.cbUseWarning.wizChecked = this.clone.useWarning;

      this.tiProcessCode.wizValue = this.clone.processCode; // alimentation du format
      let pm: FakeVO = null; // le statut en forme "objet"
      if (this.clone.processMode) {
        pm = this.modeDS.getItemByKey(this.clone.processMode);
      }
      this.modeDS.select([pm]);

      this.uploadImg.sourceObservable = this.clone.iconOrDie;


      if (this.clone.exist) {
        this.tiCode.wizDisabled = true;
      } else {
        this.tiCode.wizDisabled = false;
        setTimeout(() => {
          // sinon, pas le temps de rendre les compos enabled
          this.tiCode.wizFocus();
        }, 0);
      }
    }
  }
  
  /** Mise en place des ecouteurs de la vue */
  public wizAddListener(): void {
    WizEventManager.addListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel); // écouteur global change pour modelUpdate
  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    WizEventManager.removeListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
  }

  /** fonction de suppression du format */
  public mayDelete(): boolean {
    return !this.cantDelete && !!this.currentConnect?.exist;
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableSave(): boolean {
    let result: boolean = true; // par défaut, disabled


    if (this.clone && this.clone.code) { // si un clone, possible...
      result = false;
    }

    if (!result) { // selon update
      if (this.clone.exist && this.cantUpdate) {
        result = true;
      } else if (!this.clone.exist && this.cantCreate) {
        result = true;
      } else {
        result = !ViewData.wizUpdateModel;
      }
      
    }
    return result;
  }


 /**
   * modification d'un élément de modèle
   * @param e WizEvent
   */
  private updateModel(e: WizEvent): void {
    switch (e.component) {
      case this.tiCode:
        const text: string = this.tiCode.wizValue;
        this.clone.code = text.toUpperCase();
        break;
      case this.trsLabel:
        this.clone.labelVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.trsDesc:
        this.clone.descriptionVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.tiProcessCode:
        this.clone.processCode = this.tiProcessCode.wizValue;
        break;
      case this.ddlProcessMode:
        this.clone.processMode = this.ddlProcessMode.selectedItem.code;
        break;
      case this.uploadImg:
        this.clone.icon = e.value;
        this.uploadImg.sourceObservable = this.clone.iconOrDie; // mise à jour de l'image
        break;

      case this.trsWarnTitle:
        this.clone.warnTitleVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.trsWarnDetail:
        this.clone.warnDetailVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.trsResultError:
        this.clone.resultErrorVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.trsResultSuccess:
        this.clone.resultSuccessVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.ddResultAction:
        this.clone.resultAction = this.ddResultAction.selectedItem.code;
        break;
      // case this.tiResultAction:
      //   this.clone.resultAction = this.tiResultAction.wizValue;
      //   break;
      case this.taParameters:
        this.clone.trsParameters = this.taParameters.wizValue;
        break;
      case this.cbUseWarning:
        this.clone.useWarning = this.cbUseWarning.wizChecked;
        break;


    }
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }

  /** persistence sur save */
  public doMerge(): void {
    const errors = this.vgEditionCheck.check(true, true);
    if (!errors || (!!errors && errors.length === 0)) {
      Model.getInstance().connectEngine.merge(this.clone, this.currentConnect, this.backFromMerge.bind(this));
    } else {
      WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Callback sur retour de persistence
   * @param bddBack cnx créé ou modifié ou supprimé
   * @param operation CUD
   */
  private backFromMerge(vo: ConnectVO, operation: EM_ACTION): void {
    // console.log('cnx op', operation);
    let newSelect: ConnectVO = null;
    switch(operation) {
      case EM_ACTION.CREATE:
        this.mainDS.addItem(vo);
        newSelect = vo;
        break; 
      case EM_ACTION.UPDATE:
        this.currentConnect.source = vo.source;
        // console.log('upd', vo.source, this.currentConnect);
        newSelect = this.currentConnect;
        break; 
      case EM_ACTION.DELETE:
        this.mainDS.removeItem(vo);
        this.mainDS.clearSelection();
        break; 
    }

    this.mainDS.refresh();
    this.doSelect(newSelect);
  }


  /* #############################################################
                  gestion sélection et filtres
     ############################################################# */

  private mainFilter: FilterComponent; // filterCompo du mdMain
  /** init du filter du mdMain */
  private initMainFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /** demande de changement de sélection */
  private askSelectMain(e: WizEvent = null): void {
    const vo: ConnectVO = e.value;
    if (ViewData.wizUpdateModel) {
      e.preventDefault(); // sélection pas self && modifs en cours
      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSelect.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        vo,
        null,
        null
      ).show();
    } else {
      if (!this.mainDS.isSelected(vo)) {
        // pas encore sélectionné
        this.doSelect(vo);
      } else {
        // déjà sélectionné, déselection
        this.doSelect(null);
      }
    }
  }

  /**
   * Confirmation de la sélection du style
   */
   private confirmSelect(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const vo: ConnectVO = result.data;
      this.mainDS.toggle(vo); // on a prevent l'event, on joue l'action
      this.doSelect(this.mainDS.selectedItem);
    }
  }

  /**
   * Changement de style sélectionné
   * @param pEvent WizEvent
   */
  private doSelect(vo: ConnectVO) {
    ViewData.wizUpdateModel = false;
    if (vo) {
      this.currentConnect = vo;
      this.clone = Model.getInstance().connectEngine.clone(this.currentConnect);
    } else {
      this.currentConnect = null;
      this.clone = null;
    }
    this.feed();
  }


  /** création nouveau style */
  public askForAdd(): void {
    this.currentConnect = Model.getInstance().connectEngine.buildFake();
    this.clone = Model.getInstance().connectEngine.clone(this.currentConnect);
    this.mainDS.clearSelection();
    this.feed();
  }

  /** demande de suppression */
  public askForDelete(): void {
    WizPopUp.confirm(
      '$.common.delete.title.$',
      '$.common.delete.detail.$',
      this.doRemove.bind(this),
      CONFIRMATION_MODE.CONFIRM_CANCEL,
      this.currentConnect
    ).show();
  }

  /**
   * Suppression
   * @param result Objet de retour sur popUp de confirmation. Contient l'action choisie, et la data d'origine
   */
   private doRemove(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      Model.getInstance().connectEngine.remove(this.clone, this.currentConnect, this.backFromMerge.bind(this));
    }
  }

  /**
   * Validateur d'unicité du code
   */
    public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le _clone est null
      if (!this.clone) {
        return null;
      }
      if (this.tiCode.wizValue !== null && this.tiCode.wizValue && this.tiCode.wizValue.length > 0) {
        // CHRONO = mot réservé
        if (this.tiCode.wizValue.toUpperCase() === 'CHRONO') {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }

        // Recherche d'une autre cnx avec le même code
        let other: ConnectVO = Model.getInstance().connectMapExt?.get(Model.getInstance().domainCode)?.get(Model.getInstance().businessUnitCode)?.get(this.tiCode.wizValue.toUpperCase());

        // Si un cnx existe deja avec le meme code on affiche le message
        if (other && other.uid !== this.clone.uid) {
          const temp: WizValidationError = {
            wizError: '$.style.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }


  /** cancel */
  public doCancel(): void {
    this.clone = Model.getInstance().connectEngine.clone(this.currentConnect);
    this.feed();
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableCancel(): boolean {
    return !ViewData.wizUpdateModel;
  }



/* ################################################
                      gestion des medias
    ################################################ */

  /** affichage de l'icone de suppression des... icones */
  public hasImage(): boolean {
    return !!this.clone?.icon;
  }

  /**  de suppression des... icones */
  public clearImage(): void {
    this.clone.icon = null;
    this.uploadImg.sourceObservable = this.clone.iconOrDie;
 
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    // this.manageComponents();
  }


  /**
   * Demande de chargement d'une image
   */
   public clickForUpload(): void {
      let params: ImageUploadParameter = {
        component: this.uploadImg,
        elementRef: this.uploadImg.elementRef,
        dom: this.clone.domain,
        bu: this.clone.businessUnitCode,
        vision: ViewData.wildcardMainVision
      }
      Model.getInstance().batchEngine.loadImage(params);
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   */
  public keydownForUpload(event: KeyboardEvent): void {
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload();
    }
  }

  /**
   * Est-ce que l'utilisateur peut créer ?
   * @returns 
   */
  public get cantCreate(): boolean {
    const cant: boolean = !Model.getInstance().permissionEngine.canCreate(StaticFeatureEnum.CONNECT)
    // console.log('cancreate', can);
    return cant;
  }

  /**
   * Est-ce que l'utilisateur peut mettre à jour ?
   * @returns 
   */
  public get cantUpdate(): boolean {
    const cant: boolean = !Model.getInstance().permissionEngine.canUpdate(StaticFeatureEnum.CONNECT)
    // console.log('canUpdate', can);
    return cant;
  }

  /**
   * Est-ce que l'utilisateur peut mettre à jour ?
   * @returns 
   */
  public get cantDelete(): boolean {
    return !Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.CONNECT);
  }
}
